module.exports = __webpack_public_path__ + "img/1479924336.64c0f87d.jpg";